/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-15T11:07:07.027
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseSalesCardConsume,
	listRentHouseSalesCardConsumeInit,
	listRentHouseSalesCardConsumeByAuthorizations,
	deleteRentHouseSalesCardConsume
} from '@api/rentmanage/RentHouseSalesCardConsume';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseSalesCardConsume({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesCardConsume(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseSalesCardConsumeByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesCardConsumeByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseSalesCardConsumeInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesCardConsumeInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseSalesCardConsume({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseSalesCardConsume({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
